import client from './client';
import { config } from '../../config';
import { getUserTracking } from '../utils/create-user-tracking';

/**
 * Authenticate with LinkedIn
 * @param {*} code
 * @param {*} referral
 */
export const authenticateWithLinkedIn = async (code, referral) => {
  const tracking = await getUserTracking();

  const data = {
    code,
    platform: config.REACT_APP_PLATFORM_TYPE,
    redirect_uri: config.REACT_APP_LINKEDIN_REDIRECT_URI,
    referral,
    tracking,
  };

  const response = await client.post('authentications/linkedin', data);
  return response.data;
};

/**
 * Authenticate via Pathfix
 * @param {string} oauthId
 */
export const authenticateWithPathfix = async (oauthId, provider) => {
  const endpoints = {
    googleidentity: 'authentications/google',
    fbidentity: 'authentications/facebook',
  };

  const tracking = await getUserTracking();

  const response = await client.post(
    endpoints[provider],
    {
      oauthId,
      provider,
      platform: config.REACT_APP_PLATFORM_TYPE,
      tracking,
    },
  );
  return response.data;
};

/**
 * Authenticate with password
 * @param {*} email
 * @param {*} password
 */
export const authenticateWithPassword = async (email, password, recaptcha) => {
  const data = {
    email,
    password,
    recaptcha_token: recaptcha.recaptchaToken,
    recaptcha_version: recaptcha.recaptchaVersion,
  };

  const { REACT_APP_PLATFORM_TYPE: platform } = config;
  if (platform !== 'tester') {
    data.platform = platform;
  }

  const response = await client.post('authentications/password', data);
  return response.data;
};

/**
 * Authenticate with screener session
 * @param {*} sessionId
 * @param {*} token
 */
// FIXME: Rename this method to `authenticateWithScreenerSession`
export const authenticate = async (sessionId, token) => {
  const data = {
    session_id: sessionId,
    authentication_token: token,
  };

  const response = await client.post('authentications/screener_session', data);
  return response.data;
};

export const authenticateSchedule = async (segmentId) => {
  const data = {
    segment_id: segmentId,
  };
  const response = await client.post('authentications/schedule', data);
  return response.data;
};

export const authenticateModeratedMeeting = async (testSessionId) => {
  const data = {
    test_session_id: testSessionId,
  };
  const response = await client.post('authentications/moderated_meeting', data);
  return response.data;
};

export const authenticateWithShareCode = async (shareType, shareCode, password) => {
  const data = {
    share_code: shareCode,
    password,
  };

  const response = await client.post(`authentications/share/${shareType}`, data);
  return response.data;
};

export const authenticateWithLivestream = async (testSessionId) => {
  const data = {
    test_session_id: testSessionId,
  };

  const response = await client.post('authentications/livestream', data);
  return response.data;
};

export const authenticateWithWorkOS = async (email) => {
  const data = {
    email,
  };

  const response = await client.post('authentications/workos', data);
  return response.data;
};

export const workOSCallback = async (code) => {
  const data = {
    code,
  };

  const response = await client.post('authentications/workos/callback', data);
  return response.data;
};

export const authenticateWithTester = async (sessionId, token) => {
  const data = {
    session_id: sessionId,
    authentication_token: token,
  };

  const response = await client.post('authentications/tester', data);
  return response.data;
};
